import Vue from 'vue'

export const toEuro = (amount) => {
  return '€ ' + parseFloat(amount).toFixed(2)
}

Vue.filter('euro', function (amount) {
  return toEuro(amount)
})
